import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';

import { take } from 'rxjs/operators';
import { ApiError, MessageService } from '../../../../core';
import { PessoaContato } from '../pessoa-contato';
import { PessoaContatoTipo } from '../tipo';
import { isContatoSituacaoInativo } from '../situacao';
import { PessoaContatoHttpService } from '../services';

@Component({
    selector: 'sgt-pessoa-contato-pipeline-card',
    templateUrl: './pessoa-contato-pipeline-card.component.html',
    styleUrls: ['./pessoa-contato-pipeline-card.component.less']
})
export class PessoaContatoPipelineCardComponent implements AfterViewInit, OnDestroy {
    /** Título do card */
    @Input() title = 'Contatos';
    /** ID da pessoa dos contatos */
    @Input() idPessoa: number;

    // Messages
    /** Mensagem de carregando os contatos */
    @Input() isLoadingMessage = 'Carregando os contatos';
    /** Mensagem de erro ao pesquisar os contatos */
    @Input() searchErrorMessage = 'Erro ao carregar os contatos';
    /** Mensagem quando não for encontrado nenhum contato */
    @Input() emptyMessage = 'Nenhum contato';

    /** Evento para inserir um novo contato */
    @Output() insertContato = new EventEmitter<PessoaContatoTipo>();
    /** Evento para abrir um contato */
    @Output() open = new EventEmitter<PessoaContato>();

    /** Configs */
    @Input() listMaxHeight = '180px';

    // Collapse
    @ViewChild('collapse') collapse: ElementRef;
    isCollapseOpened = false;

    isLoading: boolean;
    isLoaded: boolean;
    contatos: PessoaContato[];

    constructor(private messageService: MessageService,
                private pessoaContatoHttpService: PessoaContatoHttpService) { }

    ngAfterViewInit() {
        // Registrando evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).on('show.bs.collapse', () => {
            this.isCollapseOpened = true;
        });
        // Registrando evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).on('hidden.bs.collapse', () => {
            this.isCollapseOpened = false;
        });
    }

    /** Abre/Fecha o collapse */
    toggleCollapse() {
        if (!this.isCollapseOpened) {
            this.openCollapse();
        } else {
            this.closeCollpase();
        }
    }

    /** Abre o collapse */
    private openCollapse() {
        (jQuery(this.collapse?.nativeElement) as any).collapse('show');
    }

    /** Fecha o collapse */
    private closeCollpase() {
        (jQuery(this.collapse?.nativeElement) as any).collapse('hide');
    }

    /** Verifica se o contato está inativo */
    isInativo(contato: PessoaContato): boolean {
        if (!contato) {
            return false;
        }
        return isContatoSituacaoInativo(contato.situacao);
    }

    /** Pesquisa os contatos */
    search(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.isLoading = true;
            this.isLoaded = false;

            this.pessoaContatoHttpService.searchContatos(this.idPessoa)
                .pipe(
                    take(1)
                )
                .subscribe(
                    contatos => {
                        this.contatos = contatos;
                        this.isLoading = false;
                        this.isLoaded = true;
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, this.searchErrorMessage, error);
                        this.isLoading = false;
                        this.isLoaded = false;
                        reject();
                    }
                );
        });
    }

    /** Emite evento para abrir o contato */
    openClick(contato: PessoaContato) {
        this.open.emit(contato);
    }

    ngOnDestroy() {
        // Removendo evento ao abrir o collapse
        jQuery(this.collapse?.nativeElement).off('show.bs.collapse');
        // Removendo evento ao fechar o collapse
        jQuery(this.collapse?.nativeElement).off('hidden.bs.collapse');
    }
}
